'use client';
import React, { useState } from 'react';
import Mydata from '../data/privacy/privacy1.json';
import Image from 'next/image';
import Link from 'next/link';
import Cancel from '../../../public/updated-home/cancelletion/privacy-and-ookies.png';
import Drop from '../../../public/updated-home/cancelletion/dropdown.svg';
import TawkTo from '../componenets/Tawko';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function Page() {
  const data = Mydata[0];
  const data1 = Mydata[1];
  const data2 = Mydata[2];

  const [showRefundContent, setShowRefundContent] = useState(false);
  const [showcontent, setShowcontent] = useState(false);

  const [rotationRefund, setRotationRefund] = useState(0);
  const [rotationContent, setRotationContent] = useState(0);

  const toggleRefundContent = () => {
    setShowRefundContent(!showRefundContent);
    setRotationRefund(showRefundContent ? 0 : 180);
    // Make sure to close the other content when toggling
    setShowcontent(false);
    setRotationContent(0);
  };

  const togglecontent = () => {
    setShowcontent(!showcontent);
    setRotationContent(showcontent ? 0 : 180);
    // Make sure to close the other content when toggling
    setShowRefundContent(false);
    setRotationRefund(0);
  };

  return (
    <div>
      <TawkTo />
      <Navbar />
      <title>Privacy policy & data protection | Prestige Ride</title>
      <meta
        name="description"
        content="Read our privacy policy and learn how we protect your data and privacy. Your personal information is handled responsibly at Prestige Ride."
      />
      <meta name="robots" content="index, follow" />
      <meta name="keywords" content="" />
      <link
        rel="canonical"
        href="https://www.prestigeride.com/privacy-and-cookies-policy"
      />

      {/* =============================== */}
      <div style={{ background: 'rgba(213, 175, 52, 0.1)' }}>
        <div className="mx-auto max-w-7xl pt-4 pb-4 px-6">
          <h1 className="text-4xl mb-2 font-bold secondary">{data.title}</h1>
        </div>
      </div>
      {/* =============================== */}

      <div className="mx-auto pt-8 max-w-7xl grid grid-cols-5 px-6 lg:gap-10">
        <div className="col-span-12 sm:col-span-1 md:col-span-1 lg:col-span-2">
          <Image src={Cancel} alt="cancellation-policy" />
        </div>
        <div className="col-span-12 sm:col-span-1 md:col-span-1 lg:col-span-3 ">
          <h2 id="visionh2" className="updatedheading visionh2 mb-2">
            Scope
          </h2>
          <p className="updatedparapremu">
            This Privacy Policy applies to the processing of personal data by
            Prestige Ride in connection with our website and mobile
            applications. We are committed to protecting your personal
            information and ensuring its security. Name and Contact Information
            of the Controller:
            <br />• Controller:
            <Link id="highlight" href="/">
              {' '}
              PrestigeRide.com
            </Link>
            <br />• Email:{' '}
            <Link id="highlight" href="mailto:contact@prestigeride.com">
              contact@prestigeride.com
            </Link>
            <br />• Name: <Link href={'#'}>Prestige Ride</Link>
            <br />
          </p>
        </div>
      </div>

      {/* ============================================= */}

      <div className="mx-auto max-w-7xl px-6 pt-6 s">
        <h2
          className="text-4xl font-bold secondary flex gap-2 pb-2 cursor-pointer"
          onClick={toggleRefundContent}
        >
          <Image
            src={Drop}
            width={20}
            height={20}
            style={{ transform: `rotate(${rotationRefund}deg)` }}
          />
          Privacy Policy
        </h2>

        {/* Render content if showRefundContent is true */}
        {showRefundContent && (
          <>
            {data1.content.map((Object, index) => (
              <div key={index}>
                <h2 className="updatedheading pb-2">{Object.title}</h2>
                <p className="updatedparapremu pb-2">{Object.des}</p>
              </div>
            ))}
          </>
        )}

        {/* Additional content */}
      </div>

      <div className="mx-auto max-w-7xl px-6 pt-6  mb-5">
        <h2
          className="text-4xl font-bold secondary flex gap-2 pb-2 cursor-pointer"
          onClick={togglecontent}
        >
          <Image
            src={Drop}
            width={20}
            height={20}
            style={{ transform: `rotate(${rotationContent}deg)` }}
          />
          Cookies Policy
        </h2>

        {/* Render content if showRefundContent is true */}
        {showcontent && (
          <>
            {data2.content1.map((Object, index) => (
              <div key={index}>
                <h2 className="updatedheading pb-2">{Object.title}</h2>
                <p className="updatedparapremu pb-2">{Object.des}</p>
              </div>
            ))}
          </>
        )}

        {/* Additional content */}
      </div>
      <Footer />
    </div>
  );
}

export default Page;
